/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { Field as a } from "./Field.mjs";
import { Form as o } from "./Form.mjs";
import { FieldArray as d } from "./FieldArray.mjs";
import { FieldWrapper as l } from "./FieldWrapper.mjs";
import { FormElement as n } from "./FormElement.mjs";
import { withIdHOC as r } from "@progress/kendo-react-common";
const m = r(o);
m.displayName = "KendoReactForm";
export {
  a as Field,
  d as FieldArray,
  l as FieldWrapper,
  m as Form,
  o as FormClassComponent,
  n as FormElement
};
